import React from 'react'

import { mq } from '@/lib/responsive'

import { Footer, Header, Contact } from '@/components/Landing'

const LandingLayout = (props) => {
  const { isAltStyle, children } = props

  return (
    <div css={{ overflow: 'hidden' }}>
      <Header isAltStyle={isAltStyle} />
      <div
        css={{
          paddingTop: '60px',
          [mq('sm')]: { paddingTop: '0' },
          [mq('md')]: { paddingTop: '72px' },
        }}
      >
        {children}
      </div>
      <Contact />
      <Footer />
    </div>
  )
}

export default LandingLayout
